/**
 * Represents the status of an incident summary.
 */
export enum IncidentSummaryStatus {
  /**
   * No report will be auto-generated.
   */
  New = 'new',
  /**
   * In the queue to generate the report.
   */
  ToProcess = 'to_process',
  /**
   * Generating report, should be ready soon.
   */
  InProcess = 'in_process',
  /**
   * Report has been generated.
   */
  Done = 'done',
}
